// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

export default useJwt({})
